import { render } from "./ButtonLoading.vue?vue&type=template&id=582b7242&scoped=true"
const script = {}

import "./ButtonLoading.vue?vue&type=style&index=0&id=582b7242&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-582b7242"

export default script